var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#3951A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0003 73.9972C57.4348 73.9972 74.0003 57.4317 74.0003 36.9972C74.0003 30.6295 72.3917 24.6375 69.5587 19.4053C63.0536 13.7206 54.5403 10.2764 45.2227 10.2764C24.7881 10.2764 8.22266 26.8418 8.22266 47.2764C8.22266 53.6441 9.83124 59.6361 12.6642 64.8682C19.1693 70.553 27.6826 73.9972 37.0003 73.9972Z",
    fill: "#4A60AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_22778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8638 31.9551C19.0821 31.9551 16.8184 34.2188 16.8184 37.0005C16.8184 39.7822 19.0821 42.046 21.8638 42.046C24.6455 42.046 26.9093 39.7822 26.9093 37.0005C26.9093 34.2188 24.6455 31.9551 21.8638 31.9551ZM21.8638 40.3642C20.0087 40.3642 18.5002 38.8556 18.5002 37.0005C18.5002 35.1455 20.0087 33.6369 21.8638 33.6369C23.7189 33.6369 25.2275 35.1455 25.2275 37.0005C25.2275 38.8556 23.7189 40.3642 21.8638 40.3642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0005 31.9551C34.2188 31.9551 31.9551 34.2188 31.9551 37.0005C31.9551 39.7822 34.2188 42.046 37.0005 42.046C39.7822 42.046 42.046 39.7822 42.046 37.0005C42.046 34.2188 39.7822 31.9551 37.0005 31.9551ZM37.0005 40.3642C35.1455 40.3642 33.6369 38.8556 33.6369 37.0005C33.6369 35.1455 35.1455 33.6369 37.0005 33.6369C38.8556 33.6369 40.3642 35.1455 40.3642 37.0005C40.3642 38.8556 38.8556 40.3642 37.0005 40.3642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1373 31.9551C49.3556 31.9551 47.0918 34.2188 47.0918 37.0005C47.0918 39.7822 49.3556 42.046 52.1373 42.046C54.919 42.046 57.1827 39.7822 57.1827 37.0005C57.1827 34.2188 54.919 31.9551 52.1373 31.9551ZM52.1373 40.3642C50.2822 40.3642 48.7736 38.8556 48.7736 37.0005C48.7736 35.1455 50.2822 33.6369 52.1373 33.6369C53.9923 33.6369 55.5009 35.1455 55.5009 37.0005C55.5009 38.8556 53.9923 40.3642 52.1373 40.3642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_22778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3636,
    height: 40.3636,
    fill: "white",
    transform: "translate(16.8184 16.8184)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.c939cf2c531b102e1d6578379fd7cb7d.svg";
export { ForwardRef as ReactComponent };